// Ultimate Reviews Scroll Fix - Height Stability Check
// Waits for Klaviyo widget height to stabilize before scrolling.

// Kill all existing scroll animations immediately
$("html, body").stop(true, true);

var lastWidgetHeight = 0;
var heightStableCounter = 0;
var scrollCheckInterval = null;
var scrollFailsafeTimeout = null;
var scrollCompleted = false;
var pendingScrollForce = false;
var scrollExecutionOptions = { behavior: 'smooth' };

// Attempt to relocate the "Read Reviews" text into the Klaviyo block so it visually belongs with the widget.
function relocateReadReviewsText() {
    var readReviewsEl = document.querySelector('p.product__text.read_review');
    if (!readReviewsEl) {
        return false;
    }

    var klaviyoWidget = document.querySelector('.shopify-app-block .klaviyo-star-rating-widget');
    if (!klaviyoWidget) {
        return false;
    }

    if (!klaviyoWidget.contains(readReviewsEl)) {
        readReviewsEl.classList.add('klaviyo-read-reviews-text');
        klaviyoWidget.classList.add('klaviyo-widget-with-read-link');

        var styleElement = klaviyoWidget.querySelector('style');
        if (styleElement) {
            klaviyoWidget.insertBefore(readReviewsEl, styleElement);
        } else {
            klaviyoWidget.appendChild(readReviewsEl);
        }
    }

    return true;
}

function ensureReadReviewsRelocation() {
    var attempts = 0;
    var maxAttempts = 20;

    var intervalId = setInterval(function () {
        attempts++;
        if (relocateReadReviewsText() || attempts >= maxAttempts) {
            clearInterval(intervalId);
        }
    }, 250);
}

// Function to scroll to the reviews section
function performScroll(options) {
    if (scrollCompleted && !pendingScrollForce) {
        return;
    }

    var opts = options || scrollExecutionOptions || {};
    var behavior = opts.behavior === 'auto' ? 'auto' : 'smooth';

    var reviewsSection = $("#fulfilled-reviews-all");
    if (reviewsSection.length) {
        var headerHeight = $("header").outerHeight() || 0;
        var targetOffset = reviewsSection.offset().top - headerHeight - 20;

        $("html, body").stop(true, true);

        var finalizeScroll = function () {
            try {
                if (history && history.replaceState) {
                    var base = window.location.pathname + window.location.search + '#fulfilled-reviews-all';
                    history.replaceState(null, document.title, base);
                } else {
                    window.location.hash = 'fulfilled-reviews-all';
                }
                sessionStorage.removeItem('scrollToReviewsPending');
            } catch (e) { }

            scrollCompleted = true;
            pendingScrollForce = false;

            if (scrollCheckInterval) {
                clearInterval(scrollCheckInterval);
                scrollCheckInterval = null;
            }
            if (scrollFailsafeTimeout) {
                clearTimeout(scrollFailsafeTimeout);
                scrollFailsafeTimeout = null;
            }
        };

        if (behavior === 'auto') {
            window.scrollTo({
                top: targetOffset,
                behavior: 'auto'
            });
            requestAnimationFrame(finalizeScroll);
        } else {
            $("html, body").animate({
                scrollTop: targetOffset
            }, 800, finalizeScroll);
        }
    }
}

// Function that checks for widget height stability
function checkWidgetStability() {
    var klaviyoWrapper = $("#klaviyo-product-reviews-wrapper");
    if (!klaviyoWrapper.length) {
        return;
    }

    var currentHeight = klaviyoWrapper.height();

    if (currentHeight > 200 && currentHeight === lastWidgetHeight) {
        heightStableCounter++;
    } else {
        heightStableCounter = 0;
    }

    lastWidgetHeight = currentHeight;

    if (heightStableCounter >= 3) {
        if (scrollCheckInterval) {
            clearInterval(scrollCheckInterval);
            scrollCheckInterval = null;
        }
        if (scrollFailsafeTimeout) {
            clearTimeout(scrollFailsafeTimeout);
            scrollFailsafeTimeout = null;
        }
        if (!scrollCompleted || pendingScrollForce) {
            performScroll(scrollExecutionOptions);
        }
    }
}

// Main function to initiate the process
function scrollToReviewsWhenStable(force, options) {
    var opts = options || {};
    var immediate = !!opts.immediate;

    pendingScrollForce = !!force;
    if (pendingScrollForce) {
        scrollCompleted = false;
    }

    lastWidgetHeight = 0;
    heightStableCounter = 0;

    if (scrollCheckInterval) {
        clearInterval(scrollCheckInterval);
        scrollCheckInterval = null;
    }
    if (scrollFailsafeTimeout) {
        clearTimeout(scrollFailsafeTimeout);
        scrollFailsafeTimeout = null;
    }

    scrollExecutionOptions = { behavior: immediate ? 'auto' : 'smooth' };

    scrollCheckInterval = setInterval(checkWidgetStability, 200);

    if (immediate) {
        performScroll(scrollExecutionOptions);
    }

    scrollFailsafeTimeout = setTimeout(function () {
        if (scrollCheckInterval) {
            clearInterval(scrollCheckInterval);
            scrollCheckInterval = null;
        }
        if (!scrollCompleted || pendingScrollForce) {
            performScroll(scrollExecutionOptions);
        }
        scrollFailsafeTimeout = null;
    }, 10000);
}

$(document).ready(function () {
    try {
        if (sessionStorage.getItem('scrollToReviewsPending') === '1') {
            $("html, body").stop(true, true);
            scrollToReviewsWhenStable(false, { immediate: true });
        }
    } catch (e) { }

    $(document).off('click', '.klaviyo-review-link');
    $(document).off('click', 'p.product__text.read_review');

    $(document).on('click', '.klaviyo-review-link', function (e) {
        var href = $(this).attr('href');
        if (!href || !href.includes('#fulfilled-reviews-all')) {
            return;
        }

        var isSamePage = false;
        if (href.charAt(0) === '#') {
            isSamePage = true;
        } else {
            var a = document.createElement('a');
            a.href = href;
            var linkHost = a.host || window.location.host;
            var linkPath = a.pathname || window.location.pathname;
            isSamePage = (linkHost === window.location.host && linkPath === window.location.pathname);
        }

        if (isSamePage) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            scrollToReviewsWhenStable(true);
        } else {
            if (e.metaKey || e.ctrlKey || e.shiftKey || (typeof e.button === 'number' && e.button !== 0)) {
                try {
                    sessionStorage.setItem('scrollToReviewsPending', '1');
                } catch (err) { }
                return;
            }

            try {
                sessionStorage.setItem('scrollToReviewsPending', '1');
            } catch (err) { }

            e.preventDefault();

            var cleanHref = href.split('#')[0];
            if (cleanHref && cleanHref.length) {
                window.location.href = cleanHref;
            } else {
                window.location.href = href;
            }
        }
    });

    $(document).on('click', 'p.product__text.read_review', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var widgetButton = document.querySelector('.klaviyo-star-rating-widget button.kl_reviews__star_rating_widget');
        if (!widgetButton) {
            widgetButton = document.querySelector('.shopify-app-block .kl_reviews__star_rating_widget');
        }

        if (widgetButton) {
            try {
                widgetButton.dispatchEvent(new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                }));
                return;
            } catch (err) {
            }
        }

        scrollToReviewsWhenStable(true);
    });

    if (window.location.hash === '#fulfilled-reviews-all') {
        scrollToReviewsWhenStable(false, { immediate: true });
    }

    ensureReadReviewsRelocation();
});

document.addEventListener('shopify:section:load', function () {
    ensureReadReviewsRelocation();
});

document.addEventListener('shopify:block:select', function () {
    ensureReadReviewsRelocation();
});

